
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" (keyup)="applySearch($event)" placeholder="શોધો.." />
                <i class="ti ti-search"></i>
            </form>
            <!-- <i class="ti ti-filter"></i> -->
            <a ><i class="ti ti-plus cursorClass" (click)="AddMemoryFolder()" *ngIf="userTypeId == 1"></i></a>
        </div>
    </div>

    <div class="add-district">
        <h5 class="mb-3"> યાદગીરી</h5>
        <hr>
    </div>
    <div class="memory-list cursorClass">
        <div class="memory-item mb-4" *ngFor="let data of memoryData" (click)="GoToGallery(data)">
            <div class="text-center" *ngIf="data.image_src!= '' ">
                <img [src]="baseUrl+''+data.image_src" (error)="errorHandler($event)">
            </div>
            <div class="text-center" *ngIf="data.image_src == '' ">
                <img src="../../../assets/img/dhaduk-logo.png" />
            </div>
            <h5>{{data.folder_name}}</h5>
        </div>
    </div>

</main>